var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasAction('list'))?_c('va-action-button',{attrs:{"hide-label":_vm.icon,"label":_vm.$t('va.actions.list'),"icon":"mdi-view-list","color":_vm.color || 'success',"text":"","exact":"","to":{ name: (_vm.resource + "_list") }}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }